module.exports = __webpack_public_path__ + "img/futura_logo_branco.75d4d5cd.svg";